import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import './BudgetAnalysis.css'
import AddInterestModal from '../Modal/AddInterestModal';
import { 
  add_account_balance_interest,
  update_account_balance_interest,
  get_departments
} from '../../helper/Api';
import { toast } from 'react-toastify';
import moment from 'moment';
import SubHeader from '../Subheader/Subheader';

const BudgetAnalysis = ({isShowPopup, previewBankAccountData, handlePopUpState, handleFilter , setDivider, fy_list}) => {
  const {authData}=useSelector((state)=>state.authData);
  const [showPreview,setShowPreview]=useState(isShowPopup);
  const [formData,setFormData]=useState({
    "id": "",
    "account_name": "",
    "bank_name": "",
    "branch_name": "",
    "ifsc_code": "",
    "ifsc_code_bank": "",
    "account_type": "",
    "account_no":"",
    "account_balance":"",
    "balance_date":"",
    "interest":"",
    "quarter":"",
    "interest_date":"",
    "email":"",
    "mobile":"",
    "l2_approval": "",
    "l3_approval": "",
    "l2_remark": "",
    "l3_remark": "",
    'added_by':authData.user.id,
    "department_id":authData.user.department_id
  });
  // const [fy_list, set_fy_list] = useState([]);
  const [tier, setTier] = useState('');
  const [department, setDepartment] = useState([]);
  const [departmentId, setDepartmentId] = useState('');
  const interest_modal=(e)=>{
    e.preventDefault();
    setFormData({
      "account_name": "",
      "bank_name": "",
      "branch_name": "",
      "ifsc_code": "",
      "account_type": "",
      "account_no":"",
      "account_balance":"",
      "balance_date":"",
      "ifsc_code_bank": "",
      "interest":"",
      "interest_date":"",
      "email":"",
      "mobile":"",
      'added_by':authData.user.id,
      "department_id":authData.user.department_id
    });
    setShowPreview(true);
  }

  const fetchDepartments = async (level) => {
          try {
              const departments = await get_departments({ department_level: level, parent_department_id:  authData.user.department_id});
              if (departments.data.status) {
                  setDepartment(departments.data.result);
              }
          } catch (error) {
              console.log("get_departments error");
          }
      }
  useEffect(() => {
    setShowPreview(isShowPopup);
    setFormData(previewBankAccountData)
  }, [isShowPopup])

  const handleSubmit=async(e)=>{
    e.preventDefault();
    try {
      let res;
      if(isShowPopup) {
        formData.l2_approval = null;
        formData.l3_approval = null;
         const {data} = await update_account_balance_interest(formData, previewBankAccountData.id);
         handlePopUpState(false);
        res = data;
      } else {
        const {data} =await add_account_balance_interest(formData);
        res = data;
      }
      if(res.status){
        setShowPreview(false);
        toast.success(res.message, {
            position: toast.POSITION.TOP_CENTER
        });
      }else{
        toast.error(res.message, {
            position: toast.POSITION.TOP_CENTER
        });
      }
    } catch (error) {
      toast.error("System Error. Try Later!", {
          position: toast.POSITION.TOP_CENTER
      });
    }
  }

  const clearFilter = () => {
    setTier('');
    setDepartmentId('');
  };
  const handleInput = async (e) => {
    const name = e.target.name;
    let value = e.target.value;
    if (name === 'tier') {
        await fetchDepartments(value);
        setTier(value);
    } else if (name === 'department_id') {
        setDepartmentId(value);
    }
  }

  const [globalDateId, setGlobalDateId] = useState(null);

  useEffect(() => {
    const storedGlobalDateId = localStorage.getItem('globalDateId');
    setGlobalDateId(storedGlobalDateId); // Store it in state
  }, [fy_list]); // Re-run if `fy_list` changes

  useEffect(()=>{
    if(departmentId || tier) {
      handleFilter(departmentId, tier);
    }
  },[departmentId, tier])

  return (
    <>
      <AddInterestModal showPreview={showPreview} setShowPreview={setShowPreview} formData={formData} setFormData={setFormData} handleSubmit={handleSubmit} handlePopUp={handlePopUpState}></AddInterestModal>
      
    </>
  )
}

export default BudgetAnalysis